(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsFilterBarSort', rmsFilterBarSort);

    function rmsFilterBarSort() {
        return {
            restrict: 'E',
            scope: {},
            controller: rmsFilterBarSortCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/filter-bar/tools/sort'
        };
    }

    function rmsFilterBarSortCtrl($scope, MainFilterBarService) {
        var vm = this;
        this.$onInit = function() {
            vm.filterBarIdentifier = $scope.$parent.vm.filterBarIdentifier;
            MainFilterBarService.sync(vm, vm.filterBarIdentifier); // this gives vm.filterBarService();

            vm.selectSort = selectSort;

            init();
        }
        function init() {
            vm.showSort = vm.filterBarService().hasType('sort');
            vm.state = vm.filterBarService().getState();
            vm.options = vm.filterBarService().getOptions('sort');

            vm.filterDisplayHtml = `<a>${vm.filterBarService().getMessageLabel('sort')} <i class='fa fa-caret-down'></i></a>`;
        }

        function selectSort(sort) {
            vm.filterBarService().applySort(sort);
            vm.togglePopover();
        }
    }
})();
